import React from "react";
import { Navigate } from "react-router-dom";
import { Page } from "@tv2no/ui-react";

export const Front = () => (
    <Page>
        <Navigate to="/lists" />
    </Page>
);
